"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributesFilterPopover = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = __importDefault(require("debounce"));
const react_redux_1 = require("react-redux");
const attributes_filter_popover_styles_1 = require("./attributes-filter-popover.styles");
const attributes_filter_utils_1 = require("./attributes-filter.utils");
const filter_attribute_item_component_1 = require("./filter-attribute-item.component");
const use_filter_selection_1 = require("./use-filter-selection");
const attributes_1 = require("../../../client/attributes");
const hooks_1 = require("../../../hooks");
const generic_1 = require("../../../generic");
const models_1 = require("../../../models");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const AttributesFilterPopover = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const filterState = (0, store_1.useAttributesFilter)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedStrategyNodeId = (0, store_1.useSelectedTreeNodeId)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [searchText, setSearchText] = (0, react_1.useState)('');
    const [debouncedSearch, setDebouncedSearch] = (0, react_1.useState)('');
    const [expandedItems, setExpandedItems] = (0, react_1.useState)([]);
    const { isAllSelected, labels, values, deselectedValues, isAttributeChecked, isAttributeIndeterminate, isValueChecked, handleToggleAttribute, handleToggleValue, handleToggleSelectAll, restoreFromState, } = (0, use_filter_selection_1.useFilterSelection)();
    const isOpen = !!anchorEl;
    const isFilterActive = (0, attributes_filter_utils_1.isAttributesFilterActive)(filterState);
    const debouncedSetSearch = (0, react_1.useMemo)(() => (0, debounce_1.default)((value) => setDebouncedSearch(value), 300), []);
    (0, react_1.useEffect)(() => () => debouncedSetSearch.clear(), [debouncedSetSearch]);
    const handleSearchChange = (0, react_1.useCallback)((value) => {
        setSearchText(value);
        debouncedSetSearch(value);
    }, [debouncedSetSearch]);
    const { productLabelFilter, productValueFilter, productMeasureFilter } = (0, react_1.useMemo)(() => {
        if (!debouncedSearch) {
            return { productLabelFilter: undefined, productValueFilter: undefined, productMeasureFilter: undefined };
        }
        return {
            productLabelFilter: {
                label: { contains: debouncedSearch, mode: graphql_1.StringFilterMode.Insensitive },
            },
            productValueFilter: {
                values: { value: { contains: debouncedSearch, mode: graphql_1.StringFilterMode.Insensitive } },
            },
            productMeasureFilter: {
                some: { dimension: { contains: debouncedSearch, mode: graphql_1.StringFilterMode.Insensitive } },
            },
        };
    }, [debouncedSearch]);
    const { data: attributes, isLoading, error, pagination: { isLoadingMore, hasNextPage, onNextPage, }, } = (0, attributes_1.useGetAllAggregatedAttributes)({
        catalogId: selectedCatalogId,
        productTreeNodeId: selectedStrategyNodeId,
        sortingItem: models_1.SortingItem.SortByTextAsc,
        productLabelFilter,
        productValueFilter,
        productMeasureFilter,
        options: { skip: !isOpen },
    });
    const lastElementRef = (0, hooks_1.useLoadMore)({
        moreItemsLoading: isLoadingMore,
        hasNextPage,
        onLoadMore: onNextPage,
    });
    const allLabels = (0, react_1.useMemo)(() => attributes.map((a) => a.label), [attributes]);
    const areAllVisibleSelected = (0, react_1.useMemo)(() => allLabels.length > 0 && allLabels.every((label) => isAttributeChecked(label)), [allLabels, isAttributeChecked]);
    // Restore state from Redux when popover opens
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            restoreFromState(filterState);
            setSearchText(filterState.searchText);
            setDebouncedSearch(filterState.searchText);
            debouncedSetSearch.clear();
            setExpandedItems([]);
        }
    }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        setExpandedItems([]);
    }, [debouncedSearch]);
    const isAtLeastOneExpanded = expandedItems.length > 0;
    const hasError = !!error;
    const isEmpty = !isLoading && !hasError && attributes.length === 0;
    const showActions = attributes.length > 0 && !hasError;
    const applyPayload = (0, react_1.useMemo)(() => (0, attributes_filter_utils_1.buildApplyPayload)(isAllSelected, labels, values, deselectedValues, searchText), [isAllSelected, labels, values, deselectedValues, searchText]);
    const isDirty = (0, react_1.useMemo)(() => (0, attributes_filter_utils_1.isFilterDirty)(applyPayload, filterState), [applyPayload, filterState]);
    const handleToggleExpand = (0, react_1.useCallback)((label) => {
        setExpandedItems((prev) => (prev.includes(label)
            ? prev.filter((l) => l !== label)
            : [...prev, label]));
    }, []);
    const handleToggleExpandAll = () => {
        setExpandedItems(isAtLeastOneExpanded ? [] : allLabels.map((l) => l));
    };
    const handleClose = () => setAnchorEl(null);
    const handleCancel = () => handleClose();
    const handleApply = () => {
        dispatch((0, store_1.enrichAISetAttributesFilter)(applyPayload));
        handleClose();
    };
    const lastFilteredIndex = attributes.length - 1;
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(attributes_filter_popover_styles_1.StyledFilterButton, { size: "small", className: (0, classnames_1.default)({ 'menu--open': isOpen || isFilterActive }), onClick: (event) => setAnchorEl(event.currentTarget) }, react_1.default.createElement(ui_components_1.Icon, { variant: "filter" })), react_1.default.createElement(material_1.Popover, { open: isOpen, anchorEl: anchorEl, onClose: handleClose, TransitionProps: { exit: false, unmountOnExit: true }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } }, react_1.default.createElement(attributes_filter_popover_styles_1.StyledFilterContainer, null, react_1.default.createElement(ui_components_1.SearchField, { value: searchText, onChange: handleSearchChange, placeholder: t({ key: 'SEARCH' }), InputProps: {
            startAdornment: (react_1.default.createElement(material_1.InputAdornment, { position: "start" }, react_1.default.createElement(ui_components_1.Icon, { variant: "search", color: ui_components_1.baseColors.primaryGreen400, className: "search-icon" }))),
        } }), showActions && (react_1.default.createElement("div", { className: "actions" }, react_1.default.createElement(ui_components_1.Button, { rounded: true, size: "small", title: t({ key: isAtLeastOneExpanded ? 'COLLAPSE_ALL' : 'EXPAND_ALL' }), onClick: handleToggleExpandAll }), react_1.default.createElement(ui_components_1.Button, { rounded: true, size: "small", title: t({ key: areAllVisibleSelected ? 'CLEAR_SELECTION' : 'SELECT_ALL' }), onClick: () => handleToggleSelectAll(allLabels) }))), react_1.default.createElement(attributes_filter_popover_styles_1.StyledFilterContent, null, isLoading && attributes.length === 0 ? (react_1.default.createElement(generic_1.LoadingIndicator, { className: "loading-indicator" })) : hasError ? (react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "empty-message" }, t({ key: 'FAIL_TO_LOAD_DATA' }))) : isEmpty ? (react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "empty-message" }, t({ key: 'NO_DATA_AVAILABLE' }))) : (react_1.default.createElement(material_1.List, { sx: {
            width: '100%',
            maxHeight: 300,
            overflow: 'auto',
            position: 'relative',
        }, subheader: react_1.default.createElement("li", null) }, attributes.map((attribute, index) => (react_1.default.createElement("div", { key: attribute.label, ref: index === lastFilteredIndex ? lastElementRef : undefined }, react_1.default.createElement(filter_attribute_item_component_1.FilterAttributeItem, { attribute: attribute, isChecked: isAttributeChecked(attribute.label), isIndeterminate: isAttributeIndeterminate(attribute.label), isExpanded: expandedItems.includes(attribute.label), valueSearch: debouncedSearch, isValueChecked: isValueChecked, onToggleAttribute: handleToggleAttribute, onToggleExpand: handleToggleExpand, onToggleValue: handleToggleValue })))), isLoadingMore && react_1.default.createElement(generic_1.LoadingIndicator, { className: "loading-indicator" })))), react_1.default.createElement(material_1.Divider, null), react_1.default.createElement("div", { className: "footer" }, react_1.default.createElement(ui_components_1.Button, { rounded: true, color: "primary", title: t({ key: 'CANCEL' }), onClick: handleCancel }), react_1.default.createElement(ui_components_1.Button, { rounded: true, color: "primary", variant: "contained", title: t({ key: 'APPLY' }), disabled: !showActions || !isDirty, onClick: handleApply }))))));
};
exports.AttributesFilterPopover = AttributesFilterPopover;
